module.exports = __webpack_public_path__ + "img/stream-first-lead.040249b.png";